import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'data'
})

export class DataPipe implements PipeTransform {
    transform(value: any): any {
        if (value != undefined && value != null) {
            if (value.length > 10) {
                    value = value + "-0300";

                var data = new Date(value);
                var dataString = data.toLocaleDateString();

                return dataString;
            }

            return value;
        }
    }

    converterDataEUA(value: any){
        if(value != undefined && value != null) {
            var auxiliar = value.toString().split('/');
            return auxiliar[1] + '/' + auxiliar[0] + '/' + auxiliar[2];
        }
    }
}


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/core/pipes/data.pipe.ts
 **/